import React, { memo } from 'react'

import { string, bool, number } from 'prop-types'

import AutoGeneratedBadge from './Components/AutoGeneratedBadge/AutoGeneratedBadge'

function ThumbImageSlide({ src = null, isAutoGenerated = false, index }) {
  return (
    <>
      <img
        alt="thumbnail"
        src={src}
        width="90"
        height="90"
        loading="lazy"
        decoding="async"
        className="gallery-area-thumbs-carousel__image-thumbnail"
      />
      {isAutoGenerated && <AutoGeneratedBadge index={index} />}
    </>
  )
}

ThumbImageSlide.propTypes = {
  src: string,
  isAutoGenerated: bool,
  index: number.isRequired,
}

export default memo(ThumbImageSlide)
